<ia-header
  [title]="'header.title' | translate"
  [breadcrumbList]="'header.breadcrumbList' | translate"
/>
<div>
  <p class="tw-px-5 tw-pt-25 tw-text-center hb-group:tw-font-hello-type">
    {{ 'screens.error.label' | translate }}
  </p>
</div>
